import Regions from './Regions';

export default Regions;



// WEBPACK FOOTER //
// ./src/scenes/Stores/components/Regions/index.ts